export default __webpack_public_path__ + "static/tracking.url-71bdbe3ca44dc7b969d180a81768a090.svg";